import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared/config/router-paths";
import { Actions, BackButton, Description, Eyebrow, Panel, Title, Wrapper } from "./styles";

type InventoryTypePlaceholderPageProps = {
  title: string;
};

export const InventoryTypePlaceholderPage = ({
  title,
}: InventoryTypePlaceholderPageProps) => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Panel>
        <Eyebrow>Inventory Type</Eyebrow>
        <Title>{title}</Title>
        <Description>
          This workspace has been created as a separate entry point for the {title} inventory.
          Dedicated tables and interactions will be added here later.
        </Description>
        <Actions>
          <BackButton onClick={() => navigate(ROUTER_PATHS.clientArea.inventory.path)}>
            Back to inventory
          </BackButton>
        </Actions>
      </Panel>
    </Wrapper>
  );
};
